(function($) {

    function getPredictiveSearchResults(query) {
        return $.ajax({
            url: `/search/suggest.json`,
            method: 'GET',
            dataType: 'json',
            data: {
            q: query,
            'resources[type]': 'product,page,collection,article',
            'resources[limit]': 40
            }
        }).then(function(response) {
            return {
            products: response.resources.results.products.map(item => ({
                title: item.title,
                url: item.url,
                image: item.image,
                vendor: item.vendor,
                price: item.price,
                min_price: item.price_min,
                max_price: item.price_max,
                min_compare_at_price: item.compare_at_price_min,
                max_compare_at_price: item.compare_at_price_max
            })),
            collections: response.resources.results.collections.map(item => ({
                title: item.title,
                url: item.url,
                image: item.image
            })),
            pages: response.resources.results.pages.map(item => ({
                title: item.title,
                url: item.url
            })),
            articles: response.resources.results.articles.map(item => ({
                title: item.title,
                url: item.url,
                image: item.image,
                published_at: item.published_at
            }))
            };
        }).catch(function(err) {
            console.error('Predictive search error:', err);
            return {
            products: [],
            collections: [],
            pages: [],
            articles: []
            };
        });
    }

    function setEmptySearch(){
        $('.predSearch__sideResultsContainer').hide();
        $('.predSearch__popularContainer').show();
        $('.predSearch__resultsContainer').hide();
        $('.predSearch__trendingContainer').show();
    }

    function setInitialSearch(searchHTML){
        $('.predSearch__resultsContainer').html(searchHTML);
        $('.predSearch__sideResults--collections .predSearch__sideResultList').html('');
        $('.predSearch__sideResults--pages .predSearch__sideResultList').html('');
        $('.predSearch__sideResults--articles .predSearch__sideResultList').html('');

        $('.predSearch__sideResultsContainer').show();
        $('.predSearch__popularContainer').hide();
        $('.predSearch__resultsContainer').show();
        $('.predSearch__trendingContainer').hide();
    }

    function fillNonProductList(array, element){
        for (i=0;i<array.length;i++){
            if (i < 3){
                var thisHTML = `
                    <a class="predSearch__popularLink" href="${array[i].url}">
                    ${array[i].title}
                    </a>
                `;
                element.append(thisHTML);
            }
        }
    }

    function fillResults(results){
        $('.predSearch__sideResults--collections').hide();
        $('.predSearch__sideResults--pages').hide();
        $('.predSearch__sideResults--articles').hide();

        $('.predSearch__sideResults--collections .predSearch__sideResultList').html('');
        $('.predSearch__sideResults--pages .predSearch__sideResultList').html('');
        $('.predSearch__sideResults--articles .predSearch__sideResultList').html('');

        if (results.collections.length > 0){
            $('.predSearch__sideResults--collections').show();
            fillNonProductList(results.collections, $('.predSearch__sideResults--collections .predSearch__sideResultList'));
        }
        if (results.pages.length > 0){
            $('.predSearch__sideResults--pages').show();
            fillNonProductList(results.pages, $('.predSearch__sideResults--pages .predSearch__sideResultList'));
        }
        if (results.articles.length > 0){
            $('.predSearch__sideResults--articles').show();
            fillNonProductList(results.articles, $('.predSearch__sideResults--articles .predSearch__sideResultList'));
        }
        if (results.products.length > 0){
            $('.predSearchCard--result').each(function(){
                var cardIndex = $(this).attr('data-index') * 1;
                var resultData = results.products[cardIndex];
                if (typeof resultData === 'undefined'){
                    $(this).find('a').hide();
                }
                else{
                    $(this).find('.predSearchCard__link').attr('aria-label', 'go to '+resultData.title+' product page');
                    $(this).find('.predSearchCard__link').attr('href', resultData.url);
                    $(this).find('.predSearchCard__image').removeClass('predSearchCard__image--searching');
                    $(this).find('.predSearchCard__image').attr('src', resultData.image);
                    $(this).find('.predSearchCard__image').attr('alt', resultData.title);
                    $(this).find('.predSearchCard__title').text(resultData.title);
                    if ((resultData.min_price * 1.0) < (resultData.min_compare_at_price * 1.0)){
                        $(this).find('.predSearchCard__saleTag').show();
                        $(this).find('.predSearchCard__standardPrice').hide();
                        $(this).find('.predSearchCard__salePrice').show();
                        $(this).find('.predSearchCard__crossPrice').show();
                        $(this).find('.predSearchCard__salePrice').text('$'+resultData.min_price);
                        $(this).find('.predSearchCard__crossPrice').text('($'+resultData.min_compare_at_price+'-$'+resultData.max_compare_at_price+')');
                    }
                    else{
                        $(this).find('.predSearchCard__standardPrice').text('$'+resultData.min_price+'-$'+resultData.max_price);
                    }
                }
            });
        }
        else{
            $('.predSearch__resultFlex').hide();
            $('.predSearch__noneFound').show();
            $('.predSearch__noneFoundSearchTerm').text($('.desktop-search__wrap form input[name="q"]').val().trim());
        }
    }

    function calculateFreeShippingProgress(cartData){
        // Free shipping updater
        var totalShip = parseInt($(".mini-cart").data("freeship"));
        var newCartTotal = cartData.items_subtotal_price;
        var awayShip = totalShip - newCartTotal;
        var shipPercent = newCartTotal / totalShip * 100;
        if (shipPercent >= 100) {
            $(".shipping-bar--progress").css("width", "100%");
            $(".mini-cart__ship").addClass("is-free");
        } else {
            if ($(".mini-cart__ship").hasClass("is-free")) {
            $(".mini-cart__ship").removeClass("is-free");
            }
            $(".free-count").text(formatter.format(awayShip / 100));
            $(".shipping-bar--progress").css("width", shipPercent + "%");
        }
    }

    function closeMini() {
        $("body").removeClass("cart-open");
        $(".mini-cart").removeClass("is-open");
        $(".mini-cart").fadeOut("fast");
        }
        function showMini() {
        $("body").addClass("cart-open");
        $(".mini-cart").fadeIn("fast");
        $(".mini-cart").addClass("is-open");

        // Set height of product list for full-height mini-cart
        // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
        // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
        // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
        // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
        // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
    }


    function bindMinicartQtySelector(){
        $(".mini-cart__list .qty button").unbind('click');
        $(".mini-cart__list .qty button").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        var qtyInput = $parent.find("input");
        var qtyInputVal = qtyInput.val();
        qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
        var lineData = $this.closest(".product").data("lineid");
        if ($this.hasClass("js-qty--plus")) {
            qtyInputVal++;
            qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
        } else {
            qtyInputVal--;
            qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
        }
        CartJS.updateItem(lineData, qtyInputVal, {}, {
            success: function success(data, textStatus, jqXHR) {
            jQuery.getJSON("/cart.js", function (cart) {
                refreshMiniCart(cart);
            });
            },
            error: function error(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
            }
        });
        });
    }

    function bindMiniCartRemove(){
        $(".mini-cart .remove-product").unbind('click');
        $(".mini-cart .remove-product").on("click", function () {
            var lineNum = $(this).closest(".product").attr("data-lineid");
            $(this).closest(".product").addClass("removed");
            CartJS.removeItem(lineNum, {
            success: function success(data, textStatus, jqXHR) {
                jQuery.getJSON("/cart.js", function (cart) {
                refreshMiniCart(cart);
                });
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                console.log(errorThrown);
            }
            });
        });
        }

    function refreshMiniCart(cartData) {
        var cartItems = cartData.items;

        // Free shipping updater
        var totalShip = parseInt($(".mini-cart").data("freeship"));
        var newCartTotal = cartData.items_subtotal_price;
        var awayShip = totalShip - newCartTotal;
        var shipPercent = newCartTotal / totalShip * 100;
        if (shipPercent >= 100) {
            $(".shipping-bar--progress").css("width", "100%");
            $(".mini-cart__ship").addClass("is-free");
        } else {
            if ($(".mini-cart__ship").hasClass("is-free")) {
            $(".mini-cart__ship").removeClass("is-free");
            }
            $(".free-count").text(formatter.format(awayShip / 100));
            $(".shipping-bar--progress").css("width", shipPercent + "%");
        }

        $(".mini-cart__list h3.text-center").remove();
        $('.mini-cart__list .product').remove();
        // If cart is now empty
        if (cartData.item_count == 0) {
            $(".mini-cart__list").prepend('<h3 class="text-center">Cart is empty</h3>');
        } else {
            // Build html of new products in cart
            $.each(cartItems, function (index, item) {
                // Opening
                
                var prodHTML = `
                    <div class="product product--cart d-flex justify-between" style="order:${index};" data-lineid="${index + 1}" data-varid="${item.id}">
                    <div class="product__image">
                    <a href="${item.url}">
                        <img src="${item.featured_image.url.replace(".jpg", "_80x.jpg").replace(".png", "_80x.png")}" srcset="${item.featured_image.url.replace(".jpg", "_160x.jpg").replace(".png", "_160x.png")} 2x" alt="${item.image.alt}">
                    </a>
                    </div>
                    <div class="product__info">
                        <div class="title d-flex">
                            <h3 class="tw-text-base tw-uppercase tw-text-mainBlack tw-font-osc tw-flex tw-justify-between">
                                <a class="no-dec trans" href="${item.url}">
                                    ${item.title}
                                </a>
                                <button class="remove-product trans animate">
                                    <span class="sr-only">Remove</span>
                                    <img src="//sconza.com/cdn/shop/t/19/assets/icon-trash.svg?v=85424820541012395581754593823" alt="Trash Icon">
                                </button>
                            </h3>
                            <div class="var tw-font-os tw-text-xs tw-font-normal tw-text-mainBlack">
                                <span>${item.options_with_values[0].value}</span>
                            </div>
                        </div>
                        <div class="actions d-flex align-center justify-between">
                            <div class="action action--qty">
                            <div class="qty d-flex align-center">
                                <button class="js-qty js-qty--mini js-qty--minus trans">
                                <span class="sr-only">Decrease</span>
                                </button>
                                <input sm-rc-quantity-selector="" type="text" value="${item.quantity}" min="1" class="qty-val">
                                <button class="js-qty js-qty--mini js-qty--plus trans">
                                <span class="sr-only">Increase</span>
                                </button>
                            </div>
                            </div>
                            <div class="price tw-text-base tw-uppercase tw-text-mainBlack tw-font-osc">
                            ${formatter.format(item.price / 100)}
                            </div>
                        </div>
                    </div>
                </div>
                `;

                $(".mini-cart__list").prepend(prodHTML);

            });
        }

        // Clear current products in cart
        $(".mini-cart__items").empty();

        // Set new subtotal
        $(".mini-cart__footer .sub-total .total").text(formatter.format(cartData.total_price / 100));

        // Set new header icon count
        $(".icon--cart .cart-count span ").text(cartData.item_count);
        
        bindMinicartQtySelector();
        bindMiniCartRemove();
        // Show mini cart
        showMini();
    }

    $(document).ready(function() {

        var $searchInput = $('.desktop-search__wrap form input[name="q"]');
        var defaultSearchHTML = $('.predSearch__resultsContainer').html();
        var searching = false;
        
        var freeShipInitialized = false;

        var cartReadyInterval = setInterval(function(){
            if (typeof CartJS === "undefined"){
                freeShipInitialized = false;
            }
            else{
                clearInterval(cartReadyInterval);
                freeShipInitialized = true;
                calculateFreeShippingProgress(CartJS.cart)
            }
        });

        $('.miniUpsellCard').each(function(){
            var thisThing = $(this);
            var variantId = $(this).attr('data-prod-id');
            if ($('.mini-cart').find('.product[data-varid="'+variantId+'"]').length > 0){
                thisThing.remove();
            }
        });

        const miniCartSlider = new Swiper('.mini-cart__upsellList', {
            loop:false,
            pagination: {
                el: '.mini-cart__upsellSliderNav',
                clickable: true
            }
        });

        $('.miniUpsellCard__buyButton').on('click', function(){
            var prodId = $(this).closest('.miniUpsellCard').attr('data-prod-id') * 1;
            var slideIndex = $(this).closest('.miniUpsellCard').attr('data-slide-index') * 1;
            CartJS.addItem(prodId, 1, {}, {
            success: function success(data, textStatus, jqXHR) {
                jQuery.getJSON("/cart.js", function (cart) {
                refreshMiniCart(cart);
                });
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                console.log(errorThrown);
            }
            });
            miniCartSlider.removeSlide(slideIndex);
        });

        $searchInput.on('input', function() {
            var query = $(this).val().trim();

            if (searching == false){
                if (query.length > 0){
                    searching = true;
                    setInitialSearch(defaultSearchHTML);
                    var searchRateLimit = setInterval(function(){
                        var currentQuery = $('.desktop-search__wrap form input[name="q"]').val().trim();
                        console.log(currentQuery+' vs '+query);
                        if (currentQuery == query){
                            setInitialSearch(defaultSearchHTML);
                            console.log('searching for:', query);
                            getPredictiveSearchResults(query).then(function(results) {
                            fillResults(results);
                            searching = false;
                            
                            clearInterval(searchRateLimit);
                            });
                        }
                        else{
                            query = currentQuery;
                        }
                    }, 300);
                }
                else{
                    setEmptySearch()
                }
            }
        });

        // PDP lightbox gallery + click-to-zoom
        (function initPdpLightbox() {
            var lightbox = document.getElementById('pdpLightbox');
            if (!lightbox || typeof Swiper === 'undefined') return;

            var stage = lightbox.querySelector('.pdp-lightbox__stage');
            var prevBtn = lightbox.querySelector('.pdp-lightbox__nav--prev');
            var nextBtn = lightbox.querySelector('.pdp-lightbox__nav--next');
            var triggers = document.querySelectorAll('.pdp-lightbox-trigger');
            if (!triggers.length) return;

            var isOpen = false;
            var isZoomed = false;
            var activeImg = null;
            var dragState = null;
            var panX = 0;
            var panY = 0;
            var zoomScale = window.matchMedia('(max-width: 768px)').matches ? 2 : 2.2;
            var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            var lightboxSwiper = new Swiper('.pdpLightboxSwiper', {
                slidesPerView: 1,
                loop: false,
                speed: reduceMotion ? 0 : 300,
                pagination: {
                    el: '.pdp-lightbox__pagination',
                    clickable: true
                },
                navigation: {
                    prevEl: prevBtn,
                    nextEl: nextBtn
                },
                on: {
                    slideChange: function () {
                        resetZoom();
                    }
                }
            });

            function applyPan() {
                if (!activeImg) return;
                activeImg.style.transform =
                    'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomScale + ')';
            }

            function resetZoom() {
                isZoomed = false;
                panX = 0;
                panY = 0;
                dragState = null;
                lightbox.classList.remove('is-zoomed');
                lightbox.querySelectorAll('.pdp-lightbox__img').forEach(function (img) {
                    img.style.transform = '';
                    img.style.transformOrigin = '';
                    img.classList.remove('is-dragging');
                });
                if (lightboxSwiper && !lightboxSwiper.destroyed) {
                    lightboxSwiper.allowTouchMove = true;
                }
            }

            function setZoom(img, originX, originY) {
                activeImg = img;
                isZoomed = true;
                panX = 0;
                panY = 0;
                lightbox.classList.add('is-zoomed');
                img.style.transformOrigin = originX + '% ' + originY + '%';
                img.style.transform = 'translate(0px, 0px) scale(' + zoomScale + ')';
                if (lightboxSwiper && !lightboxSwiper.destroyed) {
                    lightboxSwiper.allowTouchMove = false;
                }
            }

            function toggleZoom(e) {
                var img = e.target.closest('.pdp-lightbox__img');
                if (!img) return;

                if (isZoomed) {
                    resetZoom();
                    return;
                }

                var rect = img.getBoundingClientRect();
                var x = ((e.clientX - rect.left) / rect.width) * 100;
                var y = ((e.clientY - rect.top) / rect.height) * 100;
                setZoom(img, x, y);
            }

            function openLightbox(index) {
                lightbox.hidden = false;
                lightbox.setAttribute('aria-hidden', 'false');
                requestAnimationFrame(function () {
                    lightbox.classList.add('is-open');
                });
                document.body.classList.add('pdp-lightbox-open');
                isOpen = true;
                resetZoom();
                lightboxSwiper.slideTo(index || 0, 0);
                lightbox.querySelector('.pdp-lightbox__close').focus();
            }

            function closeLightbox() {
                if (isZoomed) {
                    resetZoom();
                    return;
                }
                lightbox.classList.remove('is-open');
                document.body.classList.remove('pdp-lightbox-open');
                isOpen = false;
                lightbox.setAttribute('aria-hidden', 'true');
                window.setTimeout(function () {
                    if (!isOpen) lightbox.hidden = true;
                }, reduceMotion ? 0 : 250);
            }

            // Close / unzoom via X or backdrop
            lightbox.querySelectorAll('[data-pdp-lightbox-close]').forEach(function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    closeLightbox();
                });
            });

            document.addEventListener('keydown', function (e) {
                if (!isOpen) return;
                if (e.key === 'Escape') {
                    e.preventDefault();
                    closeLightbox();
                } else if (e.key === 'ArrowLeft' && !isZoomed) {
                    lightboxSwiper.slidePrev();
                } else if (e.key === 'ArrowRight' && !isZoomed) {
                    lightboxSwiper.slideNext();
                }
            });

            triggers.forEach(function (trigger) {
                trigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    var index = parseInt(trigger.getAttribute('data-lightbox-index'), 10) || 0;
                    openLightbox(index);
                });
            });

            // Click image to zoom / unzoom
            lightbox.addEventListener('click', function (e) {
                if (e.target.closest('.pdp-lightbox__img')) {
                    // Ignore if we just finished a drag
                    if (dragState && dragState.moved) {
                        dragState = null;
                        return;
                    }
                    toggleZoom(e);
                }
            });

            // Pan while zoomed
            function onPointerDown(e) {
                if (!isZoomed) return;
                var img = e.target.closest('.pdp-lightbox__img');
                if (!img) return;
                activeImg = img;
                dragState = {
                    startX: e.clientX,
                    startY: e.clientY,
                    originX: panX,
                    originY: panY,
                    moved: false
                };
                img.classList.add('is-dragging');
                e.preventDefault();
            }

            function onPointerMove(e) {
                if (!dragState || !isZoomed || !activeImg) return;
                var dx = e.clientX - dragState.startX;
                var dy = e.clientY - dragState.startY;
                if (Math.abs(dx) > 3 || Math.abs(dy) > 3) dragState.moved = true;
                panX = dragState.originX + dx;
                panY = dragState.originY + dy;
                applyPan();
            }

            function onPointerUp() {
                if (!activeImg) return;
                activeImg.classList.remove('is-dragging');
                // Keep dragState until click handler runs so we can suppress toggle
                window.setTimeout(function () {
                    dragState = null;
                }, 0);
            }

            stage.addEventListener('mousedown', onPointerDown);
            window.addEventListener('mousemove', onPointerMove);
            window.addEventListener('mouseup', onPointerUp);

            stage.addEventListener(
                'touchstart',
                function (e) {
                    if (!isZoomed || !e.touches[0]) return;
                    onPointerDown(e.touches[0]);
                },
                { passive: false }
            );
            window.addEventListener(
                'touchmove',
                function (e) {
                    if (!dragState || !isZoomed) return;
                    e.preventDefault();
                    onPointerMove(e.touches[0]);
                },
                { passive: false }
            );
            window.addEventListener('touchend', onPointerUp);
        })();

    });
})(jQuery);